// internal deps
import { GlobalHeaderState, SwgyHeaderKeysList, showNativeHeader } from "@swiggy-private/checkout-core";
import { captureError } from "@swiggy-private/core-ui";
import { PAYLATER_DISPLAY_NAMES, PAYLATER_TYPES } from "@swiggy-private/payment-types";

// utils
import { createAndSubmitForm } from "@payment-client/utils/Form";

// interfaces
import { PAYMENT_INITIAL_STATE } from "@payment-client/components/payment-main";
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";

// constants
import { PAYMENT_BACK_ALERT_OPTIONS } from "@payment-client/constants/TextDict";

export const createRedirectToSimplHandler = (
    url: string | undefined,
    paymentResponse: GetPaymentMethodsResponse | null,
    simplPostLinkingRedirectUrl: any,
): void => {
    try {
        // Adding merchant payload to the simpl linking redirection url to help shield differentiate between prod and preprod testing
        let merchantPayload: any = {
            mid: paymentResponse?.tenant || "",
            userId: GlobalHeaderState.getHeader(SwgyHeaderKeysList.userId) ?? "",
            redirectUrl: simplPostLinkingRedirectUrl.unwrapOr(""),
        };
        merchantPayload = btoa(JSON.stringify(merchantPayload));

        url = `${url}&merchant_payload=${merchantPayload}`;

        const backURL = `${location.origin}?state=${PAYMENT_INITIAL_STATE.PAYLATER_SIMPL_LINKING_FAILED}`;

        createAndSubmitForm({ url });
        const paymentCode = PAYLATER_TYPES.SIMPL;
        showNativeHeader({
            title: PAYLATER_DISPLAY_NAMES[paymentCode],
            backURL,
            backAlert: PAYMENT_BACK_ALERT_OPTIONS,
        });
    } catch (err) {
        captureError(err);
    }
};
